import { CartEntryType } from 'utils/cart/types';

export const mapEntryTypeToOfferType = (entryType: CartEntryType) => {
  let offerType;

  switch (entryType) {
    case CartEntryType.combo:
    case CartEntryType.offerCombo:
      offerType = CartEntryType.offerCombo;
      break;
    case CartEntryType.offerDiscount:
      offerType = CartEntryType.offerDiscount;
      break;
    case CartEntryType.item:
    case CartEntryType.offerItem:
    default:
      offerType = CartEntryType.offerItem;
      break;
  }

  return offerType;
};
